import React, { useMemo } from 'react';
import { hasTheRegionOrCountry, transRegion } from '@/pages/opinion/utils';
import { getLocale, useIntl } from 'umi';
import { getCountryFlag } from '@/pages/home/_config/countries';
import TextBubbles from '@/pages/home/components/TextBubbles';
import CommonBubble from '@/pages/home/components/CommonBubble';
import BubbleCommon, {
  commonCountryAndRegionTips,
} from '@op/components/BubbleCommon';

/**
 * 关键字小组件
 * @param regionCountry            显示的关键字
 * @param sentiment_rating   分数，决定了显示的样式， 2.5分以下就是红，大于3.5为绿色，其他的为灰色
 * @param count              数量
 * @returns
 */
export default function RegionCountryItem({
  market,
  text,
  showText = true,
  className,
  textClassName,
  iconClassName,
  style = {},
  iconStyle = {},
  isGlobal = false,
  isShortText = false,
  regionTypeEn = 2,
  regionTypeCn = 4,
  bubbleText,
}: {
  market: string;
  text?: string | any;
  showText?: boolean;
  textClassName?: string;
  iconClassName?: string;
  className?: string;
  style?: any;
  iconStyle?: any;
  isGlobal?: boolean;
  isShortText?: boolean;
  regionTypeEn?: 1 | 2;
  regionTypeCn?: 4 | 5;
  /** 气泡提示文案，传入则用 Bubble 包裹，不传则普通 div */
  bubbleText?: string;
}) {
  const { formatMessage } = useIntl();

  const imgIcon = useMemo(() => {
    const flag = hasTheRegionOrCountry(market);
    let url = getCountryFlag('undefined');
    try {
      url = getCountryFlag(market);
    } catch (error) {
      console.log(error);
    }
    const imgElement = (
      <img
        src={url}
        style={iconStyle}
        className={`dbo-channellabel-icon ${iconClassName} ${
          market === 'global' ? 'dbo-channellabel-icon--global' : ''
        }`}
      />
    );

    if (flag) return imgElement;

    return (
      <BubbleCommon showIcon={false} tipsMap={commonCountryAndRegionTips}>
        {imgElement}
      </BubbleCommon>
    );
  }, [market, formatMessage]);

  const textInfo = (market: string) => {
    const isEn = getLocale() === 'en-US';
    if (market !== 'global') {
      return transRegion(market, isEn ? regionTypeEn : regionTypeCn) || market;
    }

    if (isGlobal) {
      return isEn ? 'Global' : '全球';
    }

    return formatMessage({
      id: isShortText ? 'Unidentified -4' : 'Unidentified -3',
    });
  };

  const ele = (
    <TextBubbles
      className={`dbo-channellabel-text ${textClassName}`}
      text={textInfo(market)}
      rowNum={3}
    />
  );

  return (
    <CommonBubble content={bubbleText} placement="top">
      <div className={`dbo-channellabel dbo-channellabel--market ${className}`} style={style}>
        {imgIcon}
        {showText ? text || ele : null}
      </div>
    </CommonBubble>
  );
}
